// components/FabricaMatriculasTable_v2.jsx
import React, { useMemo } from 'react'
import { ReusableTable } from 'components/Tables/ReusableTable'
import FabricaRow from './FabricaRow'
import { useTotalMo } from 'hooks/useTotalMo'
import { ordenarPorPropiedad } from 'utils/formatText'
import { redondearDecimalesToLocaleString } from 'utils/roundNumber'

  const HEADERS          = ['Matrícula', 'Importe']
  const HEADERCLASSNAMES = ['ta-left', 'ta-right']
  const FOOTERCLASSNAMES = ['ta-left', 'ta-right']

export const FabricaMatriculasTable_v2 = ({ modulos }) => {

  const { totalMoByVinculo, totalMo } = useTotalMo()

  // Suma de imports de módulos
  const totalImportProject = useMemo(() => {
    if (!modulos?.modulos) return 0
    return modulos.modulos.reduce(
      (acc, m) => acc + Number(m.totalImport),
      0
    )
  }, [modulos])

  // Total general (módulos + mano de obra)
  const totalGeneral = totalImportProject + Number(totalMo)

  // Formateamos el total para mostrarlo
  const totalFormatted = redondearDecimalesToLocaleString(totalGeneral) + ' €'

  return (
    <ReusableTable
      className="my-table"
      dataHeader={HEADERS}
      headerClassNames={HEADERCLASSNAMES}
      dataFooter={['Total', totalFormatted]}
      footerClassNames={FOOTERCLASSNAMES}
    >
     
      {modulos.modulos
        .sort(ordenarPorPropiedad('code'))
        .map((modulo, i) => (
          <FabricaRow
            key={`${modulo.externalid}-${i}`}
            modulo={modulo}
            mo={totalMoByVinculo}
          />
        ))}
    </ReusableTable>
  )
}
